
import './App.css';
import Footer from './components/pages/Footer';
import Home from './components/pages/Home';
import NavBar from './components/widgets/navigation/NavBar';

function App() {
  return (
    <div className="App">
      <NavBar/>
      <Home/>
      <Footer/>
    </div>
  );
}

export default App;
